module.exports = __webpack_public_path__ + "static/media/buzka-niebieska.8667a571.svg";